import {memo} from 'react'

import type {MemexChartConfiguration} from '../../../api/charts/contracts/api'
import type {MemexItemModel} from '../../../models/memex-item-model'
import {useChartSeries} from '../../../state-providers/charts/use-chart-series'
import {ChartByType} from './chart-by-type'

export const CurrentInsightsChart = memo<{
  configuration: MemexChartConfiguration
  filteredItems: Array<MemexItemModel> | null
  filterValue: string
  isLoading: boolean
}>(function CurrentInsightsChart({configuration, filteredItems, isLoading}) {
  const {series} = useChartSeries(configuration, filteredItems)

  return <ChartByType chartType={configuration.type} isLoading={isLoading} series={series} />
})

try{ CurrentInsightsChart.displayName ||= 'CurrentInsightsChart' } catch {}